<template>
    <div class="custom-slider">
        <input
            type="range"
            v-bind="$attrs"
        >
    </div>
</template>

<script>
export default {
    name: 'RangeSlider'
}
</script>

<style scoped lang="scss">
.custom-slider {
   --trackHeight: 7px;
   --thumbRadius: 1rem;

   // Style the input element with type "range"
   input[type="range"] {
       position: relative;
       z-index: 0;
       width: 100%;
       border-radius: 999px;
       appearance: none;

       // ::before element to replace the slider track
       &::before {
           position: absolute;
           // z-index: -1;
           width: var(--ProgressPercent, 100%);
           height: 100%;
           border: 1px solid #d2d2d2;
           border-radius: 999px;
           background: #f00;
           content: "";
           pointer-events: none;
       }

       // `::-webkit-slider-runnable-track` targets the track (background) of a range slider in chrome and safari browsers.
       &::-webkit-slider-runnable-track {
           height: var(--trackHeight);
           border-radius: 999px;
           appearance: none;
           background: #f0f0f0;
       }

       &::-webkit-slider-thumb {
           position: relative;
           z-index: 1;
           top: 50%;
           width: var(--thumbRadius);
           height: var(--thumbRadius);
           // margin-top: calc((var(--trackHeight) - var(--thumbRadius)) / 2);
           border: #000;
           border-radius: 999px;
           appearance: none;
           background: #f0f0f0;
           pointer-events: all;
           transform: translate(0, -50%);
       }

       // `::-moz-range-track` targets the track (background) of a range slider in Mozilla Firefox.
       &::-moz-range-track {
           height: var(--trackHeight);
           border: 1px solid #d2d2d2;
           border-radius: 999px;
           appearance: none;
           background: #f0f0f0;
       }
   }
}
</style>
